export default __webpack_public_path__ + "static/media/img_success.fc06e4a3.svg";